import type { ReactNode } from 'react'

export function Panel({
  title,
  actions,
  children,
  flush,
}: {
  title?: ReactNode
  actions?: ReactNode
  children: ReactNode
  flush?: boolean
}) {
  return (
    <section className="panel">
      {(title || actions) && (
        <div className="panel__header">
          {title && <h2 className="panel__title">{title}</h2>}
          {actions && <div className="row">{actions}</div>}
        </div>
      )}
      <div className={`panel__body ${flush ? 'panel__body--flush' : ''}`}>
        {children}
      </div>
    </section>
  )
}
